import { toKebabCase } from "@eusoft/webapp-core";
import { formatDateTime } from "@eusoft/webapp-framework";
import { Class } from "@eusoft/webapp-jsx";
import { formatCurrency, formatEnum, formatText } from "@eusoft/webapp-ui/utils/Format";
import { TransactionType, type ITransactionView } from "../entities/Commands";
import "./TransactionList.scss";
import { formatTransactionType } from "../helpers/Format";
import { navigatePage } from "../actions/Common";

interface TransactionListOptions {

    transactions: ITransactionView[];
}

export function TransactionList(options: TransactionListOptions) {

    const openItem = (item: ITransactionView) => {
        if (item.orderId)
            navigatePage("order-details", { id: item.orderId });
    }

    return <div className="trans-list">
        <h3>{formatText("last-transactions")}</h3>
        {options.transactions?.forEach(a => <div on-click={() => openItem(a)}>
            <Class name={toKebabCase(TransactionType[a.type])} />
            {formatTransactionType(a.type)?.icon}
            <div className="main">
                <div className="name">
                    {a.type == TransactionType.Buy ? a.salePoint.name : formatEnum(TransactionType, a.type)}
                </div>
                <div className="time">
                    {formatDateTime(a.time)}
                </div>
            </div>
            <div className="amount">
                {a.type == TransactionType.Buy ? "-" : ""}
                {formatCurrency(a.amount)}
            </div>
        </div>
        )}
    </div>
}